import { Box, useTheme } from '@mui/material';

import { useFeatureFlagSplit } from '@verantos-dev/core-utils';
import { LoadingSpinner } from '@verantos-dev/shared-components';

import { AnnotatorQueueContent } from './components/AnnotatorQueueContent';
import { AnnotatorQueueHeader } from './components/AnnotatorQueueHeader';
import { useAnnotatorQueueContent } from './components/useAnnotatorQueueContent';

export const AnnotatorQueue = () => {
  const theme = useTheme();
  // Second call to read the loading flag at the screen level; RTK Query dedupes
  // the underlying request via its cache.
  const { isAnnotationProjectsLoading } = useAnnotatorQueueContent();
  // TODO: cleanup with cp_annotation_show_dashboard_loading_spinner ff
  const showLoadingSpinner = useFeatureFlagSplit(
    'cp_annotation_show_dashboard_loading_spinner'
  ) as boolean;
  const isLoading = isAnnotationProjectsLoading;

  return (
    <Box
      sx={{
        pl: theme.spacing(6),
        pr: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
      }}
    >
      <AnnotatorQueueHeader />
      {showLoadingSpinner && isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <LoadingSpinner id="annotatorQueueLoading" />
        </Box>
      ) : (
        <AnnotatorQueueContent />
      )}
    </Box>
  );
};
